import React from 'react';

import DoubleBox from './doublebox';
import SplashPage from './splashpage';

import LaunchDarkly from '@module/launchdarkly';
import { EXPERIMENT_FREE_ACCOUNT } from '@constant/experiments';

// eslint-disable-next-line react/display-name
export default (props) => {
  return React.createElement(
    LaunchDarkly.getVariant(EXPERIMENT_FREE_ACCOUNT) ? SplashPage : DoubleBox,
    props
  );
};
